import { steHttpClient } from './httpClient';

export enum DataOwnerType {
	TENANT = 'tenant',
	LOCATION = 'location',
	GROUP = 'group',
}
export interface DataOwner {
	dataOwnerId: number;
	refId: number;
	refType: DataOwnerType;
	name: string;
	merchantId?: string;
	tenantId?: number;
}

export interface Tenant {
	tenantId: number;
	tenantName: string;
	dataOwners: DataOwner[];
}

interface TenantListResponse {
	list: Tenant[];
}

export const getDataOwner = async (dataOwnerId: number) => {
	const response = await steHttpClient.get<TenantListResponse>(`api/v1/tenants`);
	const tenants = response.data.list as Tenant[];
	return tenants
		.find((tenant) => tenant.dataOwners.some((dataOwner) => dataOwner.dataOwnerId === dataOwnerId))
		?.dataOwners.find((dataOwner) => dataOwner.dataOwnerId === dataOwnerId);
};
